import { SignedIn } from '@clerk/clerk-react';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Container>
      <Logo>
        <Link to="/">arrangemessage</Link>
      </Logo>

      <Hamburger onClick={() => setIsOpen(!isOpen)}>
        ☰
      </Hamburger>

      <Navlinks isOpen={isOpen}>
        <NavItem href="/">Home</NavItem>
        <SignedIn>
        <NavItem href="/my-blogs">My Blogs</NavItem>
        </SignedIn>
        <NavItem href="/blogs">Blogs</NavItem>
        <NavItem href="/earn-with-us">Earn With Us</NavItem>
        <NavItem href="/contact-us">Contact Us</NavItem>
        <SignedIn>
          <NavItem href="/write">Write</NavItem>
        </SignedIn>
        {/* <NavItem href="/ai-demo">AI Demo Call</NavItem> */}
      </Navlinks>
    </Container>
  );
};

// Styled Components

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 40px;
  position: relative;
  // background-color: white;
  // box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.h1`
  font-family: raritas, sans-serif;
  font-style: normal;
  color: #184A2C;
  font-size: 24px;
  font-weight: 500;
  
  a {
    text-decoration: none;
    color: inherit;
  }
`;

const Navlinks = styled.div`
  display: flex;
  gap: 20px;
  
  @media (max-width: 768px) {
    flex-direction: column;
    position: absolute;
    top: 60px;
    right: 0;
    background: white;
    width: 200px;
    text-align: right;
    padding: 15px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
  }
`;

const NavItem = styled.a`
  font-family: raritas, sans-serif;
  color: #184A2C;
  font-size: 18px;
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    color: #0f331d;
  }
`;

const Hamburger = styled.div`
  font-size: 24px;
  cursor: pointer;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;
